const n = {
  name: "WarningFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.63014 3.34944C10.1227 2.51195 11.0318 2 12 2C12.9683 2 13.8776 2.51213 14.3701 3.34986L22.3343 16.6303C22.7723 17.3414 23 18.172 23 19C23 20.6523 21.6523 22 20 22H4C2.34772 22 1 20.6523 1 19C1 18.1687 1.22923 17.3437 1.64846 16.6323L1.65282 16.6249L9.63014 3.34944ZM13 8H11V14H13V8ZM12 18.5C12.8284 18.5 13.5 17.8284 13.5 17C13.5 16.1716 12.8284 15.5 12 15.5C11.1716 15.5 10.5 16.1716 10.5 17C10.5 17.8284 11.1716 18.5 12 18.5Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as WarningFilled
};
